import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress, Alert } from '@mui/material';
import B2b from '../api/b2b';

const ConsultationWalletCard = () => {
  const [wallet, setWallet] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    B2b.getWallet()
      .then((data) => {
        if (!mounted) return;
        setWallet(data?.wallet || null);
      })
      .catch(() => {
        if (!mounted) return;
        setError(null); // usuário sem empresa: não mostra erro, apenas não renderiza
      })
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading || error || !wallet) return null;

  const { total_purchased, total_consumed, available } = wallet;
  const pct = total_purchased > 0 ? Math.round((available / total_purchased) * 100) : 0;

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 3,
        bgcolor: 'white',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        borderTop: '4px solid #51DF94',
        mb: 3
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Carteira de consultas
      </Typography>

      {available === 0 ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Seu pacote de consultas foi esgotado. Adquira novos créditos para continuar consultando.
        </Alert>
      ) : null}

      <Box sx={{ display: 'flex', gap: 3, mb: 1.5 }}>
        <Box>
          <Typography variant="caption" color="text.secondary">Adquiridas</Typography>
          <Typography variant="h6">{total_purchased}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Utilizadas</Typography>
          <Typography variant="h6">{total_consumed}</Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">Saldo</Typography>
          <Typography variant="h6" sx={{ color: available > 0 ? '#00B26C' : '#d32f2f' }}>
            {available}
          </Typography>
        </Box>
      </Box>

      <LinearProgress
        variant="determinate"
        value={pct}
        sx={{ height: 8, borderRadius: 4, bgcolor: '#eee', '& .MuiLinearProgress-bar': { background: 'linear-gradient(135deg, #6BD3FD 0%, #51DF94 100%)' } }}
      />
    </Box>
  );
};

export default ConsultationWalletCard;
